import { fetchRedeemProviderBalance } from "@shared/api";
import React, { memo } from "react";
import { Link, useHistory } from "react-router-dom";

import Login from "../../Header/Login";
import Navigation from "../../Navigation/Navigation";

const GameMenu = ({
  auth,
  exit,
  fullscreen,
  toggleFullscreen,
  wallet_integration,
  session,
}) => {
  const history = useHistory();

  async function handleGameClose() {
    try {
      if (wallet_integration && session) {
        await fetchRedeemProviderBalance();
      }
    } catch (e) {
      throw new Error(e);
    } finally {
      history.push("/");
    }
  }

  return (
    <div id="innerMenu" className="game-menu">
      <div className="game-menu__row">
        <Link className="logo" to="/" aria-label="Go home" />

        {fullscreen && (
          <div className="tools">
            <div
              onClick={handleGameClose}
              className="ico ico-close"
              aria-label="Go home"
            />

            <i
              className="ico ico-resize-in"
              aria-label="Resize game"
              role="button"
              onClick={() => toggleFullscreen()}
            />
          </div>
        )}

        <Navigation />

        <Login
          authData={auth}
          onAuthExit={exit}
          onAuthEnter={() => null}
          visible={false}
        />
      </div>
    </div>
  );
};

export default memo(GameMenu);
